const fromEntries = <T = unknown>(
  entries: Iterable<readonly [PropertyKey, T]>,
): Record<PropertyKey, T> => {
  if (entries === null || entries === undefined) {
    throw new TypeError(
      'Object.fromEntries requires a single iterable argument',
    );
  }

  const obj: Record<PropertyKey, T> = {};

  for (const pair of entries) {
    if (!Array.isArray(pair) || pair.length !== 2) {
      throw new TypeError(
        'Each entry should be an array with exactly two elements',
      );
    }

    const [key, value] = pair;

    if (
      typeof key !== 'string' &&
      typeof key !== 'number' &&
      typeof key !== 'symbol'
    ) {
      throw new TypeError(
        'Each entry in the iterable should have a valid key as the first element',
      );
    }

    obj[key] = value;
  }

  return obj;
};

if (!Object.fromEntries) {
  Object.fromEntries = fromEntries;
}

export { fromEntries };
